import React from "react";
import { css, SerializedStyles } from "@emotion/react";
import { Font } from "@moneyforward/mfx_biz_react_components";
import { Plan, ServiceStatus, ServiceType } from "@/generated/graphql_billing";
import { color } from "@/styles/theme";
import { calcPlanPrice, calcPlanPriceIncludingTax } from "@/libs/billing/plan";
import { LOAN_SERVICE_CODE } from "@/libs/billing/constants";
import {
  filterActiveOtherServices,
  shortenServiceName,
} from "@/libs/billing/service";

type Props = {
  plan: Plan;
  isPlanPriceTaxExcluded: boolean;
  containerStyle?: SerializedStyles;
};

export const PlanDetailBlock = ({
  plan,
  isPlanPriceTaxExcluded,
  containerStyle = container,
}: Props) => {
  const planPrice = isPlanPriceTaxExcluded
    ? calcPlanPrice(plan)
    : calcPlanPriceIncludingTax(plan);
  const otherServices = plan?.services
    ? filterActiveOtherServices(plan?.services)
    : [];
  const otherServicesList =
    otherServices.length > 0
      ? "その他サービス：" +
        otherServices.map((service) => service.name).join(" / ")
      : "";

  return (
    <div css={containerStyle}>
      <Font variant="mb">プラン</Font>
      <Font css={{ marginTop: 8 }}>{plan?.name}</Font>
      <div
        css={{
          marginTop: 8,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "end",
          gap: 16,
        }}
      >
        <div
          css={{
            display: "flex",
            flexDirection: "column",
            gap: 8,
          }}
        >
          <div css={{ display: "flex", gap: 8 }}>
            {plan &&
              plan?.services
                ?.filter(
                  (service) =>
                    service.status === ServiceStatus.Active &&
                    service.type === ServiceType.Mikatano &&
                    service.code !== LOAN_SERVICE_CODE
                )
                .map((service, idx) => (
                  <Font
                    css={[badgeStyle, { background: color.gray100 }]}
                    variant="s"
                    key={`service-${idx}`}
                  >
                    {service.name}
                  </Font>
                ))}
          </div>
          {otherServicesList && <Font variant="s">{otherServicesList}</Font>}
        </div>
        <Font css={{ whiteSpace: "nowrap" }}>
          {planPrice?.toLocaleString()}円/月
        </Font>
      </div>
    </div>
  );
};

const badgeStyle = css({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  lineHeight: 1.8,
  height: "100%",
  borderRadius: 9,
  paddingLeft: 8,
  paddingRight: 8,
});

const container = css({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  width: "100%",
  padding: 16,
});
